import { gql } from "@apollo/client";


export const Get_HSC_PIPELINE = gql`
query hscPipeline($params: hscPipelineInput) {
  hscPipeline(params: $params)
}
`

export const GET_HSC_PIPELINE_FEES = gql`
query hscPipelineFees($params: hscPipelineInput) {
  hscPipelineFees(params: $params)
}
`